import { ConfirmActionDialogProps } from '../components/ConfirmActionDialog';

export const defaultDialogConfig: ConfirmActionDialogProps = {
  opened: false,
  title: '',
  content: () => <></>,
  onClose: () => {},
  onConfirm: () => {},
};
